import { IEmployeeServiceMock } from './employee.mock.types';

export const mockEmployeeService = (): IEmployeeServiceMock => ({
  fetchSalaryEmployeeUsers: jest.fn(),

  fetchEmployees: jest.fn(),
  fetchEmployee: jest.fn(),

  createEmployee: jest.fn(),

  updateEmployee: jest.fn(),

  deleteEmployee: jest.fn(),

  uploadHourlyEmployees: jest.fn(),

  exportEmployeesXLSX: jest.fn(),

  // Work Schedule
  fetchEmployeeWorkSchedule: jest.fn(),
  createEmployeeWorkSchedule: jest.fn(),
  updateEmployeeWorkSchedule: jest.fn(),
  deleteEmployeeWorkSchedule: jest.fn(),

  // Departments
  fetchEmployeeTeamDepartments: jest.fn()
});
